export const enum RouteName {
  StartPage = 'startsida',
  Projects = 'projekt',
  Overview = 'oversikt',
  CalculationBudget = 'kalkylbudget',
  Forecast = 'prognos',
  Documents = 'dokument',
  ATA = 'ata',
  ATADetails = 'atadetalj',
  ATADetailsPrint = 'atadetaljprint',
  Invoices = 'fakturor',
  InvoiceDetails = 'fakturadetalj',
  Admin = 'admin',
  AdminProjectAndUsers = 'projektanvandare',
  AdminSupplierInvoices = 'leverantorsfakturor',
  AdminSuppliers = 'leverantorer',
  AdminCreateInvoices = 'skapafakturor',
  AdminEditInvoice = 'redigerafakturor',
  AdminDocuments = 'dokumenthantering',
  AuthTest = 'authtest',
}
